import React from 'react';
import { useCaptions } from '../../context/CaptionsContext';
import './Captions.css';

const CaptionStrip = () => {
  const { enabled, segments, currentSegmentIndex, narrationKey } = useCaptions();

  if (!enabled) return null;
  if (!narrationKey) return null;
  if (!segments.length) return null;

  const current = segments[currentSegmentIndex];

  return (
    <div className="cap-strip" role="region" aria-label="Live captions" aria-live="polite">
      <div className="cap-strip__inner">
        <div className="cap-strip__line cap-strip__line--current">
          {current ? current.text : '…'}
        </div>
      </div>
    </div>
  );
};

export default CaptionStrip;

